// extracted by mini-css-extract-plugin
export default {"error":"ErrorPanel_error__It7lr"};